const group = {
  en: {
    group: {
      labels: {
        name: {
          title: "Name"
        },
        title: 'Group | Groups',
      },
      form: {
        create: {
          title: "Create a new article group",
          save: "Save Group",
        }
      },
      buttons: {
        add_group: "Add Group"
      },
      messages: {
        created: 'Group successfully created.'
      },
      confirmation: {
        delete_group: {
          title: "Delete Group",
          message: "This group is linked to an AFR rule (ID: {id}, Name: {name}). If you delete the group, it will also be removed from this rule. Are you sure you want to proceed?"
        }
      }
    }
  }
}

module.exports.group = group;